module.exports = __webpack_public_path__ + "static/img/ent-77.37c03ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-77.jpg
// module id = NVEl
// module chunks = 52